import React from 'react';
import {IS_OUR_APP} from '../../utils/env';
import './DownloadBar.css';
import logo from './logo.png';
import {downloadTanTuTravel} from '../../config';
import {getQuery} from '../../utils/url';

const query = getQuery();
const CHANNEL = query.channel || '';

export default function DownloadBar(props) {
  if (IS_OUR_APP) {
    return null;
  }

  return (
    <div className='download-bar'>
      <div className='container'>
        <div className='logo'>
          <img src={logo} alt='logo' />
        </div>
        <div className='slogan'>
          <h3>探途旅行</h3>
          <p>轻松规划行程，探索世界美景</p>
        </div>
        <div className='btn'>
          <button onClick={() => {
            window.location.href = `${downloadTanTuTravel}?channel=${CHANNEL}&from=poi`;
          }}>下 载</button>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/poi2/DownloadBar.js